import React from 'react';
import { Switch } from '../../components/ui/switch';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '../../components/ui/alert-dialog';
import { Button } from '../../components/ui/button';
import { Trash2 } from 'lucide-react';
import { cn } from '../../lib/utils';

interface CategoryVisibilityToggleProps {
  categoryId: string;
  userId: string;
  isPublic: boolean;
  onVisibilityChange: (isPublic: boolean) => void;
  isImported?: boolean;
  onDeleteCategory: () => void;
}

const CategoryVisibilityToggle: React.FC<CategoryVisibilityToggleProps> = ({
  categoryId,
  userId,
  isPublic,
  isImported = false,
  onVisibilityChange,
  onDeleteCategory
}) => {
  return (
    <div className="flex items-center gap-2">
      {!isImported && (
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-500 dark:text-gray-400">Private</span>
          <Switch
            checked={isPublic}
            onCheckedChange={onVisibilityChange}
            className={cn(
              isPublic ? "bg-green-600 dark:bg-green-700" : "",
              "bg-gray-200 dark:bg-gray-700"
            )}
            aria-label="Toggle category visibility"
          />
          <span className="text-sm text-gray-500 dark:text-gray-400">Public</span>
        </div>
      )}
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button variant="ghost" size="sm" className="text-red-500 hover:text-red-600 dark:text-red-400 dark:hover:text-red-300">
            <Trash2 className="h-4 w-4" />
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent className="bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-700" aria-describedby="delete-category-description">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-gray-900 dark:text-white">Delete Category</AlertDialogTitle>
            <AlertDialogDescription id="delete-category-description" className="text-gray-600 dark:text-gray-400">
              Are you sure you want to delete this category? This action cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700">
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction 
              onClick={onDeleteCategory}
              className="bg-red-600 hover:bg-red-700 dark:bg-red-700 dark:hover:bg-red-800"
            >
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default CategoryVisibilityToggle;